class MyAccountForm {
  constructor() {
    this.myAccountFormInit();
  }

  myAccountFormInit = () => {
    const labels = document.querySelectorAll(".form-row");
    labels.forEach((label) => {
      let input = label.querySelector("input");
      if (!input) {
        return;
      }
      if (input.value != "") {
        label.classList.add("input");
      }
      input.addEventListener("animationstart", (e) => {
        if (e.animationName == "onAutoFillStart") {
          label.classList.add("active");
        }
      });
      input.addEventListener("focus", () => {
        labels.forEach((l) => {
          if (l != label) {
            l.classList.remove("active");
          }
        });
        label.classList.add("active");
      });
      input.addEventListener("input", (e) => {
        if (e.target.value != "") {
          label.classList.add("input");
        } else {
          label.classList.remove("input");
        }
      });
    });
  };
}

new MyAccountForm();
